import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'form';
const idGen = new IDGenerator('wm_wizardstep');

register('wm-wizardstep', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          const counter = idGen.nextUid();
          return `<${tagName} wmWizardstep pageContainer is-container="true" wm-navigable-element="true" #${counter}="wmWizardstep" ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
